import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SITE_NAME = 'Odium World';

/**
 * Hook to set the document title with localization support.
 * Updates automatically when language changes.
 *
 * @param titleKey - Translation key from navigation:titles namespace
 * @param dynamicTitle - Optional dynamic title (overrides titleKey)
 */
export const usePageTitle = (titleKey?: string, dynamicTitle?: string) => {
  const { t, i18n } = useTranslation('navigation');

  useEffect(() => {
    let title: string;

    if (dynamicTitle) {
      title = `${dynamicTitle} | ${SITE_NAME}`;
    } else if (titleKey) {
      const translatedTitle = t(`titles.${titleKey}`);
      title = `${translatedTitle} | ${SITE_NAME}`;
    } else {
      title = SITE_NAME;
    }

    document.title = title;
  }, [titleKey, dynamicTitle, t, i18n.language]);
};
